import { createSlice, createSelector, createEntityAdapter } from "@reduxjs/toolkit";

const totalsAdapter = createEntityAdapter();

const totals = [
	{id: 0, label: "Rooms Sold", value: 12000},
	{id: 1, label: "ADR (with comps)", value: 99.00, adornment: "$"},
	{id: 2, label: "Fixed Cost (total)", value: 0.00, adornment: "$", readOnly: true},
	{id: 3, label: "Marginal Cost Per Room", value: 0.00, adornment: "$", readOnly: true},
	{id: 4, label: "Break-even Point (rooms)", value: 0, readOnly: true}
];

const emptyInitialState = totalsAdapter.getInitialState({year: new Date().getFullYear()});
const initialState = totalsAdapter.upsertMany(emptyInitialState, totals);

const totalsSlice = createSlice({
	name: "totals",
	initialState,
	reducers: {
		updateValue: totalsAdapter.updateOne,
		updateYear(state, action) {
			state.year = action.payload
		}
	}
})

export const {
	updateValue,
	updateYear
} = totalsSlice.actions;

export default totalsSlice.reducer

export const { selectAll: selectTotals, selectById: selectTotalById } = totalsAdapter.getSelectors(state => state.costPer.totals);

export const selectTotalValues = createSelector(
	selectTotals,
	totals => totals.map(total => total)
);
